module.exports = __webpack_public_path__ + "assets/img/27_1284_big.9bd63149.jpg";